import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Stack } from "@mui/material";

import useSignInStore from "../useSignInStore";
import AuthCard from "./AuthCard";
import Content from "./Content";
import OTPVerify from "./OTPVerify";

function SignInCore() {
  const viewMode = useSignInStore((state) => state.viewMode);
  const setViewMode = useSignInStore((state) => state.setViewMode);

  const navigate = useNavigate();

  const [verifyEmail, setVerifyEmail] = useState("");
  return (
    <Stack
      direction={{ xs: "column-reverse", md: "column-reverse", lg: "row" }}
      sx={{
        justifyContent: "center",
        gap: { xs: 6, sm: 5 },
        p: { xs: 2, sm: 10 },
        m: "auto",
      }}
    >
      <Content />

      {viewMode === "signIn" && (
        <AuthCard
          title="Login"
          googleButtonText="Login with Google"
          passwordButtonText="Login with Password"
          magicCodeButtonText="Send Magic Code"
          redirectText="Don't have an account?"
          redirectButtonText="Sign Up"
          onRedirectClick={() => {
            setViewMode("signUp");
          }}
          onOptVerify={(v) => {
            setViewMode("optVerify");
            setVerifyEmail(v);
          }}
          onPasswordButtonClick={() => {
            navigate("/password");
          }}
          isSignIn
        />
      )}
      {viewMode === "signUp" && (
        <AuthCard
          title="Sign Up"
          googleButtonText="Sign up with Google"
          passwordButtonText="Sign up with Password"
          magicCodeButtonText="Send Magic Code"
          redirectText="Already have an account?"
          redirectButtonText="Login"
          onRedirectClick={() => {
            setViewMode("signIn");
          }}
          onOptVerify={(v) => {
            setViewMode("optVerify");
            setVerifyEmail(v);
          }}
          isSignIn={false}
          requireTermsCheck
          onPasswordButtonClick={() => {
            navigate("/password");
          }}
        />
      )}
      {viewMode === "optVerify" && (
        <OTPVerify
          verifyEmail={verifyEmail}
          onSignup={() => {
            setViewMode("signUp");
          }}
        />
      )}
    </Stack>
  );
}

export default SignInCore;
